import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-6 px-4 mt-8">
      <div className="flex items-center justify-center gap-1 text-sm text-gray-600">
        <span>Powered by</span>
        <a
          href="https://hmttechnologies.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-blue-600 hover:text-blue-700 transition-colors"
        >
          HMT Technologies
        </a>
      </div>
    </footer>
  );
}
